import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import { getUserInfo } from '../../user';
import { Navigate } from 'react-router-dom';
import ProjectTable from '../../components/ProjectTable';
import ProjectModal from '../../components/ProjectModal';

export default function Projects() {
  const [user, setUser] = useState(null);
  // The modal: { project: null } for a new project, { project } to edit one, or null
  const [modal, setModal] = useState(null);
  const [refreshTick, setRefreshTick] = useState(0);

  useEffect(() => { getUserInfo().then(setUser); }, []);

  if (!user) return null;
  if (!Array.isArray(user.roles) || !user.roles.includes('admin')) return <Navigate to="/" replace />;

  return (
    <Layout>
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold mb-0">Projects</h1>
      </div>
      <ProjectTable key={refreshTick} onAdd={() => setModal({ project: null })} onEdit={(project) => setModal({ project })} />
      <ProjectModal
        open={!!modal}
        project={modal?.project ?? null}
        onClose={() => setModal(null)}
        onSaved={() => setRefreshTick(t => t + 1)}
      />
    </Layout>
  );
}
